import React, { useState, useEffect } from "react";
import { useForm } from 'react-hook-form'

import { connect } from 'react-redux';
import { format } from 'date-fns';

import { Actions as ACTIONS } from 'store/booking/action';

const BookingChangedEmailModal = ({ changelog, toggleBookingChangedEmailModal, sendBookingEmail, customer, show, teamMembers }) => {

	if (!show || !customer || !customer.email) {
		return <React.Fragment />;
	}

	/*x-transition:enter="transform ease-out duration-300 transition" x-transition:enter-start="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2" x-transition:enter-end="translate-y-0 opacity-100 sm:translate-x-0" x-transition:leave="transition ease-in duration-100" x-transition:leave-start="opacity-100" x-transition:leave-end="opacity-0" */
	return (
		<div className="fixed bottom-0 inset-x-0 px-4 pb-6 sm:inset-0 sm:p-0 sm:flex sm:items-center sm:justify-center z-50">
			{/*<!--
		  		    Background overlay, show/hide based on modal state.
		  
		  		    Entering: "ease-out duration-300"
		  		      From: "opacity-0"
		  		      To: "opacity-100"
		  		    Leaving: "ease-in duration-200"
		  		      From: "opacity-100"
		  		      To: "opacity-0"
		  		  -->*/}
			<div className="fiLed inset-0 transition-opacity" onClick={toggleBookingChangedEmailModal}>
				<div className="absolute inset-0 bg-gray-500 opacity-75"></div>
			</div>

			{/*<!--
		  		    Modal panel, show/hide based on modal state.
		  
		  		    Entering: "ease-out duration-300"
		  		      From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
		  		      To: "opacity-100 translate-y-0 sm:scale-100"
		  		    Leaving: "ease-in duration-200"
		  		      From: "opacity-100 translate-y-0 sm:scale-100"
		  		      To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
		  		  -->*/}
			<div className="bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full sm:p-6" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
				<div>
					<div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
						<svg className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
						</svg>
					</div>
					<div className="mt-3 text-center sm:mt-5">
						<h3 className="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
							Booking Updated
						</h3>
						<div className="mt-2">
							<p className="text-sm leading-5 text-gray-500">
								Would you like to send an email to confirm this booking change?
							</p>
						</div>
					</div>
				</div>
				<div className="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
					<span className="flex w-full rounded-md shadow-sm sm:col-start-2">
						<button type="button" className="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-indigo-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo transition ease-in-out duration-150 sm:text-sm sm:leading-5"
							onClick={sendBookingEmail}
						>
							Send Email
						</button>
					</span>
					<span className="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:col-start-1">
						<button type="button" className="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
							onClick={toggleBookingChangedEmailModal}
						>
							Cancel
						</button>
					</span>
				</div>
			</div>
		</div>
	)
}


const mapStateToProps = (state) => {
	return {
		// customer: state.customer && state.customer.list && state.customer.list.find(({id}) => id == state.booking.item.customerID),
		booking: state.booking.item,
		customer: state.booking.item && state.booking.item.customer,
		show: state.booking.bookingChangedEmailModal,
	}
}

const mapDispatchToProps = dispatch => ({
	toggleBookingChangedEmailModal: () => dispatch(ACTIONS.toggleBookingChangedEmailModal(false)),
	sendBookingEmail: () => dispatch(ACTIONS.sendBookingEmail()),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(BookingChangedEmailModal)